import axios from "axios";

import utilsMix from "@/mixins/utilsMix";

const teamsApiUrl = "/api/v1/teams/";
function handleError(error, isNotify = false) {
  return utilsMix.methods.handleErrorMix(error, isNotify);
}

export async function getTeamsApi(limit, offset) {
  let url = `${teamsApiUrl}`;
  if (limit) {
    url += `?limit=${limit}`;
    if (offset !== undefined) url += `&offset=${offset}`;
  }
  try {
    return await axios.get(url);
  } catch (error) {
    throw handleError(error);
  }
}

export async function getAllTeamsApi(limit, offset) {
  let url = `${teamsApiUrl}all/`;
  if (limit) {
    url += `?limit=${limit}`;
    if (offset !== undefined) url += `&offset=${offset}`;
  }
  try {
    return await axios.get(url);
  } catch (error) {
    throw handleError(error);
  }
}

export async function updateTeamApi(teamId, data) {
  let url = `${teamsApiUrl}${teamId}/`;
  try {
    return await axios.patch(url, data);
  } catch (error) {
    throw handleError(error);
  }
}

export async function getTeamRolesApi() {
  let url = `${teamsApiUrl}roles`;
  try {
    return await axios.get(url);
  } catch (error) {
    throw handleError(error);
  }
}

export async function getTeamMembersApi(teamId, limit = 100) {
  let url = `${teamsApiUrl}${teamId}/members/`;
  if (limit) {
    url += `?limit=${limit}`;
  }
  try {
    return await axios.get(url);
  } catch (error) {
    throw handleError(error);
  }
}

export async function updateTeamMemberRoleApi(teamId, memberId, data) {
  let url = `${teamsApiUrl}${teamId}/members/${memberId}/`;
  try {
    return await axios.patch(url, data);
  } catch (error) {
    throw handleError(error);
  }
}

export async function deleteTeamMemberApi(teamId, memberId) {
  let url = `${teamsApiUrl}${teamId}/members/${memberId}`;
  try {
    return await axios.delete(url);
  } catch (error) {
    throw handleError(error);
  }
}

export async function getOutgoingInvitationsApi(teamId) {
  let url = `${teamsApiUrl}${teamId}/invitations/`;
  try {
    return await axios.get(url);
  } catch (error) {
    throw handleError(error);
  }
}

export async function createTeamInvitationApi(teamId, data) {
  let url = `${teamsApiUrl}${teamId}/invitations/`;
  try {
    return await axios.post(url, data);
  } catch (error) {
    throw handleError(error);
  }
}

export async function updateTeamInvitationApi(teamId, inviteId, data) {
  let url = `${teamsApiUrl}${teamId}/invitations/${inviteId}/`;
  try {
    return await axios.patch(url, data);
  } catch (error) {
    throw handleError(error);
  }
}

export async function deleteTeamInvitationApi(teamId, inviteId) {
  let url = `${teamsApiUrl}${teamId}/invitations/${inviteId}/`;
  try {
    return await axios.delete(url);
  } catch (error) {
    throw handleError(error);
  }
}

export async function getIncomingInvitationsApi() {
  let url = `${teamsApiUrl}invitations/`;
  try {
    return await axios.get(url);
  } catch (error) {
    throw handleError(error);
  }
}

export async function acceptTeamInvitationApi(invationId) {
  let url = `${teamsApiUrl}invitations/${invationId}/accept/`;
  try {
    return await axios.post(url);
  } catch (error) {
    throw handleError(error);
  }
}

export async function rejectTeamInvitationApi(teamId) {
  let url = `${teamsApiUrl}invitations/${teamId}/reject/`;
  try {
    return await axios.post(url);
  } catch (error) {
    throw handleError(error);
  }
}
